import React from "react";
import HealingIcon from "@mui/icons-material/Healing";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AssignmentIcon from "@mui/icons-material/Assignment";
import HistoryIcon from "@mui/icons-material/History";
import AttachmentIcon from "@mui/icons-material/Attachment";

const iconMap = {
  Healing: HealingIcon,
  Visibility: VisibilityIcon,
  LocalHospital: LocalHospitalIcon,
  LocalOffer: LocalOfferIcon,
  MedicalServices: MedicalServicesIcon,
  Assignment: AssignmentIcon,
  History: HistoryIcon,
  Attachment: AttachmentIcon,
};

export const resolveSectionIcon = (iconKey) => {
  const IconComponent = iconMap[iconKey];
  if (!IconComponent) return null;
  return <IconComponent style={{ marginRight: "8px" }} />;
};

